// 此处自定义校验手机号码js逻辑
let validatePhone = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("phone", removeSpace(2, value), callback);
};
// 此处自定义校验任务名称
let validateTaskName = (rule, value, callback) => {
  // 调用方法
  verifyRegular("taskName", removeSpace(1, value), callback);
};
// 校验任务负责人
let validateName = (rule, value, callback) => {
  // 清空空格
  verifyRegular("name", removeSpace(2, value), callback);
};
// 此处自定义校验手机号码js逻辑
let validateMobile = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("mobile", value, callback);
};
// 校验地址
let validateEmail = (rule, value, callback) => {
  // 调用方法
  verifyRegular("email", removeSpace(1, value), callback);
}
// 校验地址
let validateAddress = (rule, value, callback) => {
  // 调用方法
  verifyRegular("address", value, callback);
};
// 开户行校验
let validateRefund = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("merchant", value, callback);
};
// 开户行校验
let validateBank = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("bank", value, callback);
};
// 银行账户校验
let validateBankAccount = (rule, value, callback) => {
  // 调用验证方法
  verifyRegular("bankAccount", value, callback);
};
// 此处自定义校验备注信息
let validateRemark = (rule, value, callback) => {
  // 调用方法
  if (value != "") {
    verifyRegular("taskName", value, callback);
  } else {
    callback();
  }
};
var validatePass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入密码"));
  } else {
    callback();
  }
};
// 校验证件号码
let validateCode = (rule, value, callback) => {
  // 调用方法
  verifyRegular("code", value, callback);
};

export default {
  task: {
    // ---------------------新建任务
    taskName: [
      {required: true, message: "请输入任务名称", trigger: "blur"},
      {max: 20, message: "最长20个字符", trigger: "blur"},
      {validator: validateTaskName, message: "请输入正确的任务名称", trigger: "blur"}
    ],
    taskType: [
      {required: true, message: "请选择任务类型", trigger: "change"}
    ],
    taskTime: [
      {required: true, message: "请输入计划开始时间", trigger: "blur"}
    ],
    taskPrincipal: [
      {required: true, message: "请输入任务负责人", trigger: "blur"},
      {min: 2, message: "负责人请输入 2-20 位字符", trigger: "blur"},
      {max: 20, message: "负责人请输入 2-20 位字符", trigger: "blur"},
      {validator: validateName, message: "负责人只能输入汉字", trigger: "blur"}
    ],
    taskPeriod: [
      {required: true, message: "请输入任务周期", trigger: "blur"},
      {max: 4, message: "任务周期最长只能输入4个字符", trigger: "blur"},
      {required: true, pattern: /^[0-9]*[1-9][0-9]*$/, message: "任务周期只能输入正整数", trigger: "blur"}
    ],
    taskBudget: [
      {required: true, message: "请输入任务预算", trigger: "blur"},
      {max: 8, message: "金额最长只能输入8个字符", trigger: "blur"},
      // 该正则支持输入正整数和小数,不支持输入0及负数
      {
        required: true,
        pattern: /^(?:[1-9][0-9]*(\.[0-9]+)?|0\.[0-9]+)$/,
        message: "任务预算只能输入正整数",
        trigger: "blur"
      }
      // { required: true, pattern: /^[0-9]*[1-9][0-9]*$/, message: "任务预算只能输入正整数", trigger: "blur" }
    ],
    taskPrincipalPhone: [
      {required: true, message: "请输入联系电话", trigger: "blur"},
      {validator: validatePhone, message: "请输入正确的电话号码", trigger: "blur"}
    ],
    taskDesc: [
      {required: true, message: "请输入任务详情", trigger: "blur"},
      {max: 500, message: "最长500个字符", trigger: "blur"},
      {min: 20, message: "最少20个字符", trigger: "blur"},
      {validator: validateTaskName, message: "任务详情不符合规则", trigger: "blur"}
    ]
  },
  ordersRules: {
    // ---------------------新增订单

  },
  calculator: {
    // ---------------------费用管理-充值账户-计算器
    paymentAmount: [
      {required: true, message: "支付金额不能为空", trigger: "blur"},
      {max: 20, message: "金额最长输入20个字符", trigger: "blur"},
      {required: true, pattern: /^(?:[1-9][0-9]*(\.[0-9]+)?|0\.[0-9]+)$/, message: "支付金额需大于零", trigger: "blur"}
    ],
    rechargeAmount: [
      {required: true, message: "充值金额不能为空", trigger: "blur"},
      {max: 20, message: "金额最长输入20个字符", trigger: "blur"},
      // 该正则支付宝输入正整数和小数,不支持输入0及负数
      {required: true, pattern: /^(?:[1-9][0-9]*(\.[0-9]+)?|0\.[0-9]+)$/, message: "充值金额需大于零", trigger: "blur"}
    ],
  },
  orderPwd: {
    // ---------------------新增订单-确认密码
    pwd: [
      {required: true, message: "支付密码不能为空", trigger: "blur"}
    ]
  },
  invoice: {
    // ---------------------发票申请/收件人管理
    expressName: [
      {required: true, validator: validateName, message: "姓名只能输入汉字", trigger: "blur"}
    ],
    expressPhone: [
      {required: true, message: "请输入手机号码", trigger: "blur"},
      {required: true, validator: validateMobile, message: "请输入正确的手机号码", trigger: "blur"}
    ],
    expressEmail: [
      {required: true, message: "请输入邮箱", trigger: "blur"},
      {required: true, validator: validateEmail, message: "请输入正确的邮箱", trigger: "blur"}
    ],
    expressAddress: [
      {required: true, message: "请输入地址", trigger: "blur"},
      {max: 100, message: "最长输入100个字符", trigger: "blur"},
      {validator: validateAddress, message: "地址输入不正确", trigger: "blur"}
    ],
  },
  balance: {
    // ---------------------余额明细
    refundfee: [
      {required: true, message: "请输入退款金额", trigger: "blur"}
    ],
    refundBank: [
      {required: true, message: "请输入账户名称", trigger: "blur"},
      {max: 100, message: "账户名称最长输入100个字符", trigger: "blur"},
      {validator: validateRefund, message: "账户名称输入格式不正确", trigger: "blur"},
    ],
    refundBankName: [
      {required: true, message: "请输入开户行名称", trigger: "blur"},
      {max: 100, message: "开户银行最长输入100个字符", trigger: "blur"},
      {validator: validateBank, message: "开户银行输入格式不正确", trigger: "blur"},
    ],
    refundAccount: [
      {required: true, message: "请输入银行卡号", trigger: "blur"},
      {validator: validateBankAccount, message: "请输入正确的银行卡号", trigger: "blur"},
    ]
  },
  recharge: {
    // ---------------------充值记录
    serviceId: [
      {required: true, message: "请选择服务商", trigger: "change"}
    ],
    accountId: [
      {required: true, message: "请选择账户名称", trigger: ["blur", "change"]}
    ],
    rechargeType: [
      {required: true, message: "请选择充值类型", trigger: ["blur", "change"]}
    ],
    bankCode: [
      {required: true, message: "请选择银行", trigger: "change"}
    ],
    transferAmount: [
      {required: true, message: "请输入转账金额", trigger: "blur"}
    ],
    postscript: [
      {max: 500, message: "最长500个字符", trigger: "blur"},
      {validator: validateRemark, message: "备注信息不符合规则", trigger: "blur"}
    ],
    amount: [
      {required: true, message: "请输入充值金额", trigger: "blur"},
      {max: 13, message: "充值金额最大输入10位数", trigger: "blur"}
    ]
  },
  login: {
    // ---------------------登录
    username: [
      {required: true, message: "账号不能为空", trigger: "blur"},
    ],
    password: [
      {validator: validatePass, trigger: "blur"}
    ],
    authcode: [
      {required: true, message: "验证码不能为空", trigger: "blur"},
    ],
  },
  control: {
    // ---------------------用户管理
    name: [
      {required: true, message: "请输入姓名", trigger: "blur"},
      {required: true, validator: validateName, message: "姓名只能输入汉字", trigger: "blur"}
    ],
    mobile: [
      {required: true, message: "请输入手机号", trigger: "blur"},
      {required: true, validator: validateMobile, message: "请输入正确的手机号码", trigger: "blur"}
    ]
  }
}



// WEBPACK FOOTER //
// ./src/utils/formCheck.js